import {
  langsList,
  countryOfTrackid,
  countryOfSupportWallet,
  countryOfSupportKCard,
  countryRegionLangMap,
  countryLangNameMap,
} from '@/config/country'

export const downloadAppLink = ''

export const DESKTOP = 'desktop'
export const GAME_TURBO = 'game_turbo'
export const MOBILE = 'mobile'
export const H5 = 'h5'
export const APP = 'app'

export const gameIconMaps = {
  freefire: require(`@/assets/images/detail/freefire/icon.png`),
  lordsmobile: require(`@/assets/images/detail/lordsmobile/icon.png`),
  genshin: require(`@/assets/images/detail/genshin/icon.png`),
  'genshin-en': require(`@/assets/images/detail/genshin/icon.png`),
  pubgm: require(`@/assets/images/detail/pubgm/icon.png`),
}

export const gameSkuIconMaps = {
  freefire: require(`@/assets/images/order/pic-freefire.png`),
  lordsmobile: require(`@/assets/images/order/pic-lordsmobile.png`),
  genshin: require(`@/assets/images/order/pic-genshin.png`),
  'genshin-en': require(`@/assets/images/detail/genshin/icon.png`),
  pubgm: require(`@/assets/images/order/pic-pubgm.png`),
}

/*
记录语料库现有的国家（线上有域名和服务的）和多语言,
注意：langs 第一位为默认语言
若不需要切换国家和语言的功能，则注释掉
-----
*/
export const REGION_LANG_MAP = countryRegionLangMap()
/* 与 REGION_LANG_MAP 每一个子项内 children 的 value 一致 */
export const LANG_NAME_MAP = countryLangNameMap()

/* ！！！切记：一定与现有的语料库包含的语言保持一致
注意：
1.中间是短横线 （为了兼容处理浏览器检测到的语言）
2.若一个国家有多种语言，请把默认语言写在前面！
*/
export const LocaleList = langsList()

// 根据新增的国家 需要查询code
// 代号构成：1+三位数字国家代码（参考链接：https://zh.m.wikipedia.org/wiki/ISO_3166-1）
export const regionCodeMap = countryOfTrackid()

// 当前允许开放钱包入口的地区，以后若开放所有国家，记得更改相关引用。【全部国家】
export const walletAccessibleRegions = countryOfSupportWallet()

// 登录类型
export const LOGIN_TYPE = {
  1: 'google',
  2: 'facebook',
  3: 'vk',
}

// 不允许展示切换国家和登录按钮的地区
export const hideLoginRegions = ['in', 'it']

// 横屏引导路由白名单
// 该白名单内的路由，在移动端浏览器正常打开时，不展示横屏引导
export const landScapeRouterWhiteList = {}

// 开放K-Card的国家
export const kCardRegions = countryOfSupportKCard()

// 主端重构（用到了 PublicHeader 的）深色版页面，数组每一项是路径名称
export const darkBgPages = [
  'order',
  'order-detail',
  'pay-result',
  'privacy',
  'terms',
]

const fb = 'https://m.facebook.com/TopLupeTopup/'
const vk = 'https://vk.com/toplupeofficial'
const telegram = 'https://t.me/TopLupe_TG'

export const officialLinks = {
  fb,
  telegram,
  vk,
}
